import { Component } from '@angular/core';
import { CDATAConnectorInfo } from '../../../../../../../models/datamodel/adbinfo.model';
import { OAuthService } from '../../../../../../../services/oauth.service';
import { ACDATAConnectorPanel } from '../a.cdata.connector.panel';

@Component({
    selector: 'msaccess-connector-panel',
    templateUrl: './msaccess.connector.panel.html'
})
export class MSAccessConnectorPanel extends ACDATAConnectorPanel {
    static GetInfo(): CDATAConnectorInfo {
        return {
            Caption: '@@Microsoft Access',
            Type: 'evidanza.Database.CData.CDataConnector.ConnectorsInfo.MSAccessInfo',
            ControlType: MSAccessConnectorPanel,
            Default: {
                ConnectionType: 0,
                AuthScheme: 0,
                SSHAuthMode: 0
            }
        };
    }

    constructor(private service: OAuthService) {
        super();
    }

    authenticate() {
        if (this.DataSource && this.DataSource.SID) {
            this.service.GetOAuthURL(this.DataSource.SID, "CData").subscribe(x => {
                if (x) {
                    window.open(x, '_blank');
                }
            });
        }
    }
}